import React from 'react';
import { Box, Typography, Slider, TextField, InputAdornment } from '@mui/material';
import { Opacity } from '@mui/icons-material';

const MARKS = [
  { value: 0, label: '0%' },
  { value: 25, label: '25%' },
  { value: 50, label: '50%' },
  { value: 75, label: '75%' },
  { value: 100, label: '100%' },
];

export default function TankLevelInput({ value, onChange }) {
  const handleSlider = (e, v) => onChange(v);
  const handleInput = (e) => {
    const v = parseInt(e.target.value, 10);
    if (!isNaN(v) && v >= 0 && v <= 100) onChange(v);
  };

  const color = value <= 20 ? 'error' : value <= 40 ? 'warning' : 'primary';

  return (
    <Box sx={{ px: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          <Opacity sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
          Livello serbatoio
        </Typography>
        <TextField
          size="small"
          type="number"
          value={value ?? ''}
          onChange={handleInput}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
            inputProps: { min: 0, max: 100, style: { width: 40, textAlign: 'right' } }
          }}
          sx={{ width: 100 }}
        />
      </Box>
      <Slider
        value={value ?? 0}
        onChange={handleSlider}
        step={5}
        marks={MARKS}
        min={0}
        max={100}
        valueLabelDisplay="auto"
        color={color}
        sx={{ mt: 0 }}
      />
    </Box>
  );
}
